import React, { MouseEventHandler, ReactNode, useEffect, useRef } from 'react';
import { ColorProps } from 'styled-system';

import Link from 'components/Link';
import { setupLinkTracker } from 'utils/analytics';

type Props = ColorProps & {
  'aria-label'?: string;
  className?: string;
  children?: ReactNode;
  'data-qa-id'?: string;
  eventName?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties?: Record<string, any>;
  href: string;
  waitForHref?: boolean;
  tabIndex?: string;
  target?: string;
  title?: string;
  rel?: string;
  onClick?: MouseEventHandler;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line consistent-return
const updateTracker = (eventName, eventProperties, linkRef) => {
  if (eventName && linkRef && linkRef.current) {
    return setupLinkTracker(eventName, eventProperties)(linkRef.current);
  }
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const TrackedLink = ({ waitForHref, ...props }: Props) => {
  const linkRef = useRef(null);
  useEffect(() => {
    const clickHandler = updateTracker(
      props.eventName,
      props.eventProperties,
      linkRef
    );
    const el = linkRef.current;
    return () => {
      if (el && clickHandler) {
        el.removeEventListener('click', clickHandler);
      }
    };
  }, [props.eventName, props.eventProperties]);
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Link key={props.eventName} {...props} ref={linkRef} />;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const TrackedConditionalLink = ({
  link,
  children,
  ...props
}: {
  'aria-label'?: string;
  link: string | null | undefined;
  children: ReactNode;
  eventName?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties?: Record<string, any>;
  'data-qa-id'?: string;
  tabIndex?: string;
}) =>
  link ? (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TrackedLink data-qa-id={props['data-qa-id']} href={link} {...props}>
      {children}
    </TrackedLink>
  ) : (
    children
  );
// eslint-disable-next-line import/no-default-export
export default TrackedLink;
